import angular from 'angular'
import { vn } from 'vend-number'

/**
 * Filter for converting a value to absolute
 *
 * @module webregister.filters.wrMakeAbsolute
 */
angular.module('webregister.filters').filter('wrMakeAbsolute', function () {
  return function (num: $TSFixMe) {
    if (!num) {
      return
    }

    return vn(num).absoluteValue().toNumber()
  }
})
